<template>
  <b-modal ref="modalImportMercuComplementaire" size="lg" title="Importer un fichier de mercuriale complementaire"
      ok-title="Fermer"
      :ok-only=true
      :hide-header-close="fichierEnCours"
      no-close-on-backdrop
      @show="initialiserModale()"
      @ok="fermerImport()">
      <template slot="default">
        <div style="display: inline">
          <div class="container-fluid card card-body">
            <div class="row ">
              <div class="col-6 form-group">
                <label>Famille</label>
                <v-select v-model="familleSelectionnee" :options="optionsFamilles" label="texte" value="valeur" :clearable="false" placeholder="Sélectionner une famille" @input="selectFamilleDeProduit"></v-select>
              </div>
              <div class="col-6 form-group">
                <label>Fournisseur</label>
                <v-select v-model="fournisseurSelectionne" :options="optionsFournisseurs" label="texte" value="valeur" :clearable="false" placeholder="Sélectionner un fournisseur"></v-select>
              </div>
            </div>
            <div class="row">
                <div class="col-6 form-group">
                    <label>Date Début tarifs</label>
                    <v-date-picker class="date-picker" :min-date="dateMinimum" :columns="1" :step="1" v-model="dateTarif" :popover="{ visibility: 'click' }">
                        <template v-slot="{ inputValue, inputEvents }">
                        <input :value="inputValue" v-on="inputEvents"/>
                        </template>
                    </v-date-picker>
                </div>
                <div class="col-6 form-group">
                    <label>Taux Mercuriale du fichier</label>
                    <v-select v-model="mercurialeSelectionne" :options="optionsMercuriales" label="texte" value="valeur" :clearable="false" placeholder="Sélectionner une lettre de mercu"></v-select>
                </div>
            </div>
            <hr>
            <div class="row importFichier">
              <div class="col-2">
                <button class="btn btn-primary" @click="$refs.importFichierMercu.click()">Choisir Fichier</button>
                <input type="file" accept=".xls,.xlsx" @change="choisirFichierMercu($event)" style="display: none" ref="importFichierMercu" />
              </div>
              <div class="col-8 importFichier">
                <label>{{ nomDuFichier }}</label>
              </div>
              <div class="col-2 aligner-droite">
                <button :disabled="nomDuFichier == '' || !importPossible" class="btn btn-success" @click="importerFichierMercu()">Importer</button>
              </div>
            </div>
          </div>

          <div v-if="!resultatImportFichier && fichierEnCours" class="container-fluid card card-body">
            <div class="row">
              <div class="col-12 form-group">
                <i class="fas fa-spinner fa-spin mr-2"></i>{{ etatImportFichier }}
              </div>  
            </div>
          </div>

          <div v-if="resultatImportFichier"> <!--On affiche une ligne par fichier avec le résultat général-->
            <div class="container-fluid card card-body">
              
              <div class="row" v-if="resultatImportFichier.erreurs.length === 0 && resultatImportFichier.avertissements.length === 0" :key="'resultOk'" id="nomFichierOk">
                <div class="col-12 form-group">
                  <i class='fas fa-check-circle text-primary mr-2'></i>
                  <span>Fichier {{ resultatImportFichier.nomFichier }} du fournisseur {{ resultatImportFichier.nomFournisseur }} pour la famille {{ resultatImportFichier.nomFamille }} est importé avec succès</span>
                </div>
              </div>  
              <div v-else>
                <template v-for="(erreur, iErreur) in resultatImportFichier.erreurs">
                    <div class="row" :key="'result-'+iErreur" :id="'nomFichierErreurs-'+iErreur" :href="'#detailErreur-'+iErreur">
                        <div class="col-12 form-group">
                            <i class='fas fa-exclamation-circle text-error mr-2'></i>
                            <span>{{ erreur }} - Fichier non importé !</span>
                        </div>
                    </div>
                </template>
                <template v-for="(avert, iAvert) in resultatImportFichier.avertissements">
                    <div class="row" :key="'result-'+iAvert" :id="'nomFichierErreurs-'+iAvert" :href="'#detailErreur-'+iAvert">
                        <div class="col-12 form-group">
                            <i class='fas fa-exclamation-circle text-warning mr-2'></i>
                            <span>{{ avert }}</span>
                        </div>
                    </div>
                </template>
              </div>
              
            </div>
          </div>

        </div>
      </template>
    </b-modal>
</template>

<script>

import { obtenirLettresMercuriales, importerProduitsComplementaires } from '@/api/gpao/mercuriales'
import { connecteData } from "@/mixins/connecteData"
import { arrondiMercuriale } from '@/helpers/utils'
import { formatageDate } from '@/mixins/dateFormats'

export default {
  name: "ModalImportMercuComplementaire",
  props: { 
    listeFournisseurs: [],
    optionsFamilles: [],
   },
  mixins: [ connecteData, formatageDate ],
  data() {
  return {
    optionsFournisseurs: [],
    optionsMercuriales: [],
    familleSelectionnee: {},
    fournisseurSelectionne: {},
    mercurialeSelectionne: {},
    dateTarif: null,
    familleSelectionneeId: null,
    fournisseurSelectionneId: null,
    fichierEnCours: false,
    etatImportFichier: "",
    formData: null,
    selectedFile: null,
    resultatImportFichier : null,
    disabledDates: [],
    idFamilleInit: null,
    idFournisseurInit: null,
    }
  },
  watch: {
    
  },
  computed: {
    contenuDuFichier() {
      return this.formData ?? new FormData()
    },
    nomDuFichier() {
      return this.selectedFile?.name ?? ""
    },
    importPossible() {
        return this.familleSelectionnee && this.familleSelectionnee.valeur && this.fournisseurSelectionne && this.fournisseurSelectionne.valeur && this.dateTarif && this.mercurialeSelectionne && this.mercurialeSelectionne.valeur
    },
    dateMinimum() {
      let demain = new Date()
      demain.setDate(demain.getDate() + 1)
      return demain
    },
  },
  methods: {

    async initialiserModale() {
      //on affiche la modale de suivi du chargement avec l'etat initial
      this.etatImportFichier = "Controle et chargement du fichier en cours ..."
      this.optionsMercuriales = await this.construireListeMercuriale()

      if (this.idFamilleInit && this.idFournisseurInit) {
        //on initialise les combo famille et fournisseur
        this.fournisseurSelectionne = {}
        this.familleSelectionnee = this.optionsFamilles.find(f => f.valeur === this.idFamilleInit)  
        this.fournisseurSelectionne.valeur = this.idFournisseurInit
        this.selectFamilleDeProduit(this.familleSelectionnee)
      }
    },
    async construireListeMercuriale() {
      let response = await obtenirLettresMercuriales()

      let liste = []
      let tmpLettre = response.data

      liste = tmpLettre.map((t) => {
        let rObj = {}
        rObj.valeur = t.lettre
        rObj.texte = t.lettre
        return rObj
      });

      return liste
    },
    construireListeFournisseur(idFamille, fournisseurId) {
      let liste = []

      if (!idFamille)
        return liste
      
      let tmpFour = this.listeFournisseurs.filter(f => f.familles.some(i => i === idFamille))

      liste = tmpFour.map((t) => {
        let rObj = {}
        rObj.valeur = t.id
        rObj.texte = t.nom
        return rObj
      });

      if (fournisseurId && liste.find(l => l.valeur === fournisseurId)) {
        this.fournisseurSelectionne = liste.filter(l => l.valeur === fournisseurId)
      }
        

      return liste
    },
    selectFamilleDeProduit(event) {
      this.optionsFournisseurs = this.construireListeFournisseur(event.valeur, this.fournisseurSelectionne?.valeur)
      if (!this.optionsFournisseurs.find(o => o.id === this.fournisseurSelectionne?.valeur)) {
        this.fournisseurSelectionne = null
      }
      if (this.optionsFournisseurs?.length === 1) {
        this.fournisseurSelectionne = this.optionsFournisseurs[0]
      }
    },
    choisirFichierMercu(event) {
      //on récupère le fichier à traiter
      this.fichierEnCours = false
      if (event.target.files.length != 0) {
        this.formData = new FormData()
        this.selectedFile = event.target.files[0]

        if (this.selectedFile.size > (1024 * 1024 * 100)) {
          // Fichier de 100 Mo maximum
          this.alerteErreur("Le fichier que vous tentez d'importer est trop volumineux (" + arrondiMercuriale(this.selectedFile.size / 1024 / 1024) + " Mo). Taille maximale : 100 Mo.")
          return
        }

        this.formData.append('fichier', this.selectedFile)
      }
    },
    controleAvantImport() {
      if (!this.familleSelectionnee) {
        this.alerteErreur("La famille est obligatoire")
        return false
      }
      return true
    },
    async importerFichierMercu() {
      if (!this.controleAvantImport())
        return

      this.fichierEnCours = true
      this.resultatImportFichier = null
      this.FTEnCours = false

      //on appel l'API de chargement du fichier et on affiche le résultat dans la modale, via la variable resultatImportFichier
      try {
        let resp = await importerProduitsComplementaires(this.fournisseurSelectionne.valeur, this.familleSelectionnee.valeur, this.formatDatePourApiSansSeparation(this.dateTarif), this.mercurialeSelectionne.valeur, this.contenuDuFichier);
        this.resultatImportFichier = resp.data

        //On initialise la modale pour pouvoir refaire un import directement, sauf famille et date ...
        if (!this.resultatImportFichier.erreurs?.length) {
          this.mercurialeSelectionne = null
          this.fournisseurSelectionne = null
        }
      } catch(err) {
        let res = {
          erreurs: [],
          avertissements: []
        }

        res.erreurs.push("Import du fichier impossible : " + err)
        
        this.resultatImportFichier = []
        this.resultatImportFichier.push(res)
      }

      // Traitement terminé
      this.fichierEnCours = false

      // Réinitialisation du fichier traité pour enchainer les imports de fichiers
      this.selectedFile = null
      this.formData = null
      this.$refs.importFichierMercu.value = ""
    },
    fermerImport() {
      if (this.resultatImportFichier) {
        this.$emit("refreshMercuriale")
        this.hide()  
      }
    },
    show(famId, fourId) {
      this.selectedFile = null
      this.formData = new FormData()
      this.resultatImportFichier = null
      
      this.mercurialeSelectionne = null
      this.fournisseurSelectionne = null
      this.familleSelectionnee = null

      this.idFamilleInit = famId
      this.idFournisseurInit = fourId

      this.$refs.modalImportMercuComplementaire.show()
    },
    hide() {
      if (this.resultatImportFichier) {
        this.$refs.modalImportMercuComplementaire.hide()
      }
    }
  }
}
</script>